import Axios from "@/plugins/Axios";

export class BancosService {
  async getBanco(configuracaoId) {
    const response = await Axios().get(`bancos/${configuracaoId}`);
    return response.data;
  }

  async criarBanco(dados) {
    const response = await Axios().post("bancos", dados);
    return response.data;
  }

  async atualizarBanco(id, dados) {
    const response = await Axios().put(`bancos/${id}`, dados);
    return response.data;
  }
}

export default new BancosService();
